import * as storage from './storage'
import * as apiAuto from './api-auto'
import * as utils from './utils'
import * as mask from './mask'
import * as validate from './validateForm'

export default {
    storage,
    apiAuto,
    utils,
    mask,
    validate
}
